module.exports = __webpack_public_path__ + "img/device.0c07a994.svg";